import { Breakpoint } from 'theme/Theme';
import { SerializedStyles, Theme, css } from '@emotion/react';

export type ResponsiveSizeMap<T> = { [key in Breakpoint]?: T };

export type ResponsiveParameter<T> = ResponsiveSizeMap<T> | T;

const isResponsiveMapping = <T>(obj: T | ResponsiveSizeMap<T>): obj is ResponsiveSizeMap<T> => {
  return (obj as ResponsiveSizeMap<T>).xs !== undefined;
};

export const generateResponsiveMapping = <T>(
  theme: Theme,
  responsiveParam: T | ResponsiveSizeMap<T>,
  func: (size: T) => SerializedStyles | SerializedStyles[]
) => {
  const styles = [];
  if (isResponsiveMapping(responsiveParam)) {
    if (responsiveParam.xs) {
      styles.push(css`
        ${func(responsiveParam.xs)}
      `);
    }
    if (responsiveParam.sm) {
      styles.push(css`
        ${theme.breakpoints.up('sm')} {
          ${func(responsiveParam.sm)}
        }
      `);
    }
    if (responsiveParam.md) {
      styles.push(css`
        ${theme.breakpoints.up('md')} {
          ${func(responsiveParam.md)}
        }
      `);
    }
    if (responsiveParam.lg) {
      styles.push(css`
        ${theme.breakpoints.up('lg')} {
          ${func(responsiveParam.lg)}
        }
      `);
    }
    if (responsiveParam.lgx) {
      styles.push(css`
        ${theme.breakpoints.up('lgx')} {
          ${func(responsiveParam.lgx)}
        }
      `);
    }
    if (responsiveParam.xl) {
      styles.push(css`
        ${theme.breakpoints.up('xl')} {
          ${func(responsiveParam.xl)}
        }
      `);
    }
  } else {
    styles.push(css`
      ${func(responsiveParam)}
    `);
  }
  return styles;
};
